import React from 'react'

import './Hamburger.scss';

export default function Hamburger() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 75 51" version="1.1" xmlns="http://www.w3.org/2000/svg" className='hamburger'>
            <g transform="matrix(1,0,0,1,-4049.5,-19.5)">
                <g transform="matrix(1,0,0,1,61,0)">
                    <g id="Menu-sharp" transform="matrix(0.192708,0,0,0.192708,3976.67,-4.66667)">
                        <path d="M64,384L448,384L448,341.33L64,341.33L64,384ZM64,277.33L448,277.33L448,234.67L64,234.67L64,277.33ZM64,128L64,170.67L448,170.67L448,128L64,128Z" />
                    </g>
                </g>
            </g>
        </svg>

    )
}